import './EventEnded.scss';

const formatMilliseconds = (milliseconds) => {
  if (!milliseconds && milliseconds !== 0) {
    return '';
  }

  return (milliseconds / 1000).toFixed(2) + 's';
}

const EventEnded = ({winner}) => {
  return (
    <div className="event-ended mt-5">
        <div className="event-ended__thanks">Thanks for playing.</div>
        {winner &&
          <div className="event-ended__winner mt-4">
            <div className="event-ended__label">Winner</div>
            <div className="event-ended__name">{winner.name || winner.initials}</div>
            <div className="event-ended__details">
              {winner.correctAnswerCount} correct &middot; {formatMilliseconds(winner.totalCorrectElapsedMilliseconds)}
            </div>
          </div>
        }
    </div>
  );
}

export default EventEnded;